// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskAgencyDigit {
  public insertIconValidate = true;

  public validateAllDigit = false;

  public maxLength = 5;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      const formatedValue = value.replace(/[^\d]/g, '');
      return { formatedValue, formatedCursorPosition: cursorPosition };
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    if (value.length > this.maxLength) return false;
    return true;
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['AGENCY_DIGIT']];
  }
}
